var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { connect } from "react-redux";
import { IdErrorCore } from "../../constants/IdErrorCore";
import { IdStyles } from "../../less/IdStyles";
import { IdLoca } from "../../utils/i18n/IdLoca";
import { utilLoca } from "../../utils/i18n/utilLoca";
import { StatusCode } from "../../utils/network/generated/protoTypes";
import { DialogWrapper } from "../dialog/DialogWrapper";
import { actionErrorResolveError } from "../errors/actionError";
import { ButtonPrimary } from "../generic/common/ButtonPrimary";
import { TextInput } from "../generic/text-input/TextInput";
import { TextLoca } from "../generic/text/TextLoca";
import { actionModalClose } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
import { actionSetPlayerName } from "./actionSetPlayerName";
import { mapTextError } from "./mapTextError";
var DialogSetPlayerNameDOM = /** @class */ (function (_super) {
    __extends(DialogSetPlayerNameDOM, _super);
    function DialogSetPlayerNameDOM(props) {
        var _this = _super.call(this, props) || this;
        _this.PlayerNameMinLength = 3;
        _this.PlayerNameMaxLength = 20;
        _this.onConfirmClick = function () {
            var _a = _this.props, onSetName = _a.onSetName, onErrorResolve = _a.onErrorResolve, errorStatusCode = _a.errorStatusCode;
            var username = _this.state.username;
            if (errorStatusCode) {
                onErrorResolve();
            }
            if (username.length === 0) {
                _this.setState({
                    descIdLoca: IdLoca.error_atLeastOneLetter,
                });
                return;
            }
            if (onSetName) {
                onSetName(username);
            }
        };
        _this.onChange = function (text) {
            _this.setState({
                username: text,
            });
        };
        _this.state = {
            descIdLoca: undefined,
            username: props.currentName,
        };
        return _this;
    }
    DialogSetPlayerNameDOM.prototype.componentDidUpdate = function (prevProps) {
        var errorStatusCode = this.props.errorStatusCode;
        if (errorStatusCode && prevProps.errorStatusCode !== errorStatusCode) {
            this.setState({
                descIdLoca: mapTextError.get(errorStatusCode),
            });
        }
    };
    DialogSetPlayerNameDOM.prototype.render = function () {
        var _a = this.props, onClose = _a.onClose, currentName = _a.currentName;
        var _b = this.state, descIdLoca = _b.descIdLoca, username = _b.username;
        return (React.createElement(DialogWrapper, { titleLocaId: IdLoca.choosePlayerNameDialog_title, onClose: onClose, className: IdStyles.ModalBackgroundQuickSell },
            React.createElement("div", { className: "flex flex--stacked flex--aligned flex--around w100 h100" },
                React.createElement("div", { className: "set-player-name__desc " + IdStyles.TextNormal + " w100" },
                    React.createElement(TextLoca, { id: IdLoca.choosePlayerNameDialog_desc })),
                React.createElement(TextInput, { style: "name-input", placeholder: currentName, onChange: this.onChange, value: username, onSubmit: this.onConfirmClick, maxLength: this.PlayerNameMaxLength, minLength: this.PlayerNameMinLength }),
                React.createElement("div", { className: "set-player-name__error w100" }, descIdLoca && (React.createElement(TextLoca, { className: IdStyles.TextNegative, id: descIdLoca }))),
                React.createElement(ButtonPrimary, { onClick: this.onConfirmClick },
                    React.createElement("div", null,
                        React.createElement(TextLoca, { className: IdStyles.TextButtonDefault, id: IdLoca.confirm }))))));
    };
    return DialogSetPlayerNameDOM;
}(React.Component));
var mapState = function (state) {
    var errorStatusCode = state.errors.TextErrors.length > 0
        ? state.errors.TextErrors[state.errors.TextErrors.length - 1]
        : StatusCode.Undefined;
    var currentName = state.playerInfo.name || utilLoca.get(IdLoca.choosePlayerNameDialog_enterTextField);
    return {
        currentName: currentName,
        errorStatusCode: errorStatusCode,
    };
};
var mapDispatch = function (dispatch) { return ({
    onClose: function () { return dispatch(actionModalClose(IdModal.SetPlayerName)); },
    onErrorResolve: function () { return dispatch(actionErrorResolveError(IdErrorCore.TextErrors)); },
    onSetName: function (username) { return dispatch(actionSetPlayerName(username)); },
}); };
export var DialogSetPlayerName = connect(mapState, mapDispatch)(DialogSetPlayerNameDOM);



//////////////////
// WEBPACK FOOTER
// ./src/features/set-player-name/DialogSetPlayerName.tsx
// module id = 2897
// module chunks = 3